const selectAuthenticate = state => {
  return {
    ...state.login
  };
};

export { selectAuthenticate };
